import MkuTableItem from '../table/src/table-item';

MkuTableItem.install = function (Vue) {
  Vue.component(MkuTableItem.name, MkuTableItem);
};

export default MkuTableItem;
